import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dropdown, MenuItem } from 'react-bootstrap';
import enhanceWithClickOutside from 'react-click-outside';

const types = [
  {
    value: 'outcome',
    label: 'Outcome',
  },
  {
    value: 'type',
    label: 'Type',
  },
  {
    value: 'size',
    label: 'Size',
  },
];

class CategoryDropdown extends Component {
  constructor() {
    super();
    this.state = {
      dropdownOpen: false,
    };
    this.handleToggle = this.handleToggle.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleToggleTypeItem = this.handleToggleTypeItem.bind(this);
  }

  handleToggle(dropdownOpen) {
    this.setState({ dropdownOpen });
  }

  handleClickOutside() {
    this.setState({ dropdownOpen: false });
  }

  handleToggleTypeItem(type) {
    this.setState({ dropdownOpen: false });
    this.props.handleTypeChange(type.value);
  }

  render() {
    const { dropdownOpen } = this.state;
    const { type } = this.props;
    const selected = types.find(t => t.value === type);
    const dropdownTypeLabel = selected ? selected.label : 'Select a type';

    return (
      <Dropdown
        id="category-dropdown"
        onToggle={this.handleToggle}
        open={dropdownOpen}
      >
        <Dropdown.Toggle bsSize="small">
          <span>{dropdownTypeLabel}</span>
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {types.map(t => (
            <MenuItem
              active={type === t.value}
              key={t.value}
              onSelect={() => this.handleToggleTypeItem(t)}
            >
              {t.label}
            </MenuItem>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}

CategoryDropdown.propTypes = {
  handleTypeChange: PropTypes.func,
  type: PropTypes.string,
};

CategoryDropdown.defaultProps = {
  type: 'outcome',
  handleTypeChange: () => {},
};

export default enhanceWithClickOutside(CategoryDropdown);
